import script from "./Col3Layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Col3Layout.vue?vue&type=script&setup=true&lang=ts"

import "./Col3Layout.vue?vue&type=style&index=0&id=8113f716&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8113f716"]])

export default __exports__